// 接口请求基本配置
import apiConfig from '~/assets/js/api/index'
import apiList from '~/env.config'
import { assign, langFn } from '~/assets/js/utils.js'
const { fxClient } = apiList

export default ({ $axios, store, $winstonLog, $cookies, error }, inject) => {
  // ---------- 处理请求拦截的准备工作（开始） ----------
  const [baseURL, timeout, requests, errUrlList] = ['', 20000, [], []]
  let isRefreshing = false // 是否正在刷新、存储请求的数组
  // 挂起请求
  function subscribeTokenRefresh (cb) {
    requests.push(cb)
  }
  // 执行挂起的请求（数组中的请求得到新的token之后自执行，用新的token去请求数据）
  function onRrefreshed (token) {
    requests.map(cb => cb(token))
  }
  // ---------- 处理请求拦截的准备工作（结束） ----------

  // 用于 getToken 的裸 axios 实例（不带任何拦截器，避免循环调用）
  const rawAxios = $axios.create({ timeout: 15000 })

  // 获取/刷新token
  async function getToken () {
    let newObj = { status: 0, token: '' }
    isRefreshing = true // 开始请求接口
    try {
      const { data: aObj = {} } = await rawAxios.post(`${fxClient}/oauth2/authorize`, { // 第一步：获取授权码
        response_type: 'code',
        scope: 'email address',
        client_id: 'YWdncmVnYXRpb24tYXV0aGVudGljYXRpb24taWQ=',
        provision_key: 'wiki-aggregation-layer-key',
        authenticated_userid: 'authenticated_tester'
      })
      const { data: tObj = {} } = await rawAxios.post(`${fxClient}/oauth2/token`, { // 第二步：获取访问码
        grant_type: 'authorization_code',
        client_id: 'YWdncmVnYXRpb24tYXV0aGVudGljYXRpb24taWQ=',
        client_secret: 'YWdncmVnYXRpb24tYXV0aGVudGljYXRpb24tc2VjcmV0',
        code: aObj?.redirect_uri?.split('=')[1]
      })
      const { access_token: ntoken = '' } = tObj || {}
      $cookies.set('auth', ntoken, { maxAge: 1200, path: '/' }) // 存储token
      newObj = { status: 1, token: ntoken }
    } catch (err) {}
    isRefreshing = false // 接口请求结束
    return newObj
  }

  // 接口报错，容错处理
  const errorHandler = (err = {}) => {
    const errCode = err?.response?.status || ''
    const { url = '', method = '', params = {}, data = {}, headers = {} } = err?.config || {}
    $winstonLog?.error({ url, method, status: errCode, headers, params, data, message: err?.message }) // 写入日志
    if (process.server) error({ statusCode: errCode })
    if (errCode == 401) { // token失效时，先清理token，再重新获取
      // await getToken()
      // const { headers = {}, url = '' } = err?.config || {}
      // errUrlList.push(headers?.Route || url)
      // let countNum = 0
      // errUrlList.forEach((item) => { // 防止接口一直报401就频繁请求的问题
      //   if (item == headers?.Route || url) countNum++
      // })
      // if (countNum < 3) {
      //   return new Promise((resolve) => {
      //     requests.push(() => {
      //       resolve(request(err?.config))
      //     })
      //     if (requests?.length) { // 执行被暂时挂起的请求
      //       Promise.resolve().then(() => {
      //         requests.forEach(cb => cb())
      //         requests = []
      //       })
      //     }
      //   })
      // }

      const { headers = {}, url = '' } = err?.config || {}
      let countNum = 0
      errUrlList.push(headers?.Route || url)
      errUrlList.forEach((item) => { // 防止接口一直报401就频繁请求的问题
        if (item == (headers?.Route || url)) countNum++
      })
      if (!isRefreshing) {
        getToken().then((res) => {
          onRrefreshed(res?.token)
          requests.length = 0
        })
      }
      if (countNum < 3) {
        const retry = new Promise((resolve) => {
          subscribeTokenRefresh((accessToken) => {
            err.config.headers.Authorization = `Bearer ${accessToken}`
            resolve(request(err?.config))
          })
        })
        return retry
      }
    }
    return Promise.reject(error)
  }

  // 创建axios请求
  const request = $axios.create({ baseURL, timeout })

  // 请求拦截
  request.interceptors.request.use(async (config) => {
    const bfp = $cookies.get('wiki-bfp') ? $cookies.get('wiki-bfp') : '822ca7b3261a0b2ec10c8cdabfb5a0ea'
    let base = `999,0,2,999,0,${bfp},0`
    let basehash = '999,0,2,999,0,0'
    if (store.getters.isFxCom) {
      base = `999,0,2,999,0,${bfp},0`
      basehash = '999,0,2,999,0,0'
    } else if (store.state.myCountry == 'cn') {
      base = `999,0,1,999,1,${bfp},1`
      basehash = '999,0,1,999,1,1'
    } else {
      base = `999,0,2,999,0,${bfp},0`
      basehash = '999,0,2,999,0,0'
    }

    const { locale = '', countryCode = '', ip = '' } = store.state
    assign(config.headers, {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'x-forword-for': ip,
      CountryCode: countryCode,
      LanguageCode: locale,
      BasicData: base,
      wsc: 2,
      basehash
    })
    // 服务端请求
    const isPost = config?.data // 获取当前时间戳和token有效时长
    if (isPost && !isPost?.apiLanguage) assign(config.data, { apiLanguage: langFn(locale) }) // 接口参数增加“当前语言”
    if (process.server) return config
    // 客户端请求
    const token = $cookies.get('auth')
    if (token) { // 存在token且尚未失效时
      config.headers.Authorization = `Bearer ${token}`
      return config
    } else { // 不存在token时
      if (!isRefreshing) {
        const { token = '' } = await getToken()
        config.headers.Authorization = `Bearer ${token}`
        onRrefreshed(token)
        return config
      }
      const retry = new Promise((resolve) => {
        subscribeTokenRefresh((accessToken) => {
          config.headers.Authorization = `Bearer ${accessToken}`
          resolve(config)
        })
      })
      return retry
    }
  }, errorHandler)

  // 响应拦截
  request.interceptors.response.use((res) => {
    // const { code = 200, ErrorCode = 200, Data = '', result = '' } = res?.data
    // if (ErrorCode != 200 || ![0, 200].includes(code)) return process.client ? res?.data : error({ statusCode: 404 }) // 数据返回不正常，客户端请求的接口返回错误数据，服务端请求的接口进入错误页面
    // else return (Data || result) ? Promise.resolve(Data || result) : res.data // 两者只要有一个字段存在数据，就返回数据

    // if (ErrorCode != 200 || ![0, 200].includes(code)) return process.client ? res?.data : error({ statusCode: 404 }) // 数据返回不正常，客户端请求的接口返回错误数据，服务端请求的接口进入错误页面
    // else return res?.data?.data || res?.data // 两者只要有一个字段存在数据，就返回数据
    const { succeed = true, Data = '', data = '' } = res?.data
    if (!succeed) return process.client ? (data || Data || res?.data) : error({ statusCode: 404 }) // 数据返回不正常，客户端请求的接口返回错误数据，服务端请求的接口进入错误页面
    else return (data || Data) || (res?.data) // 两者只要有一个字段存在数据，就返回数据
  }, errorHandler)

  // 模块接口注入
  const apiObj = {}
  for (const i in apiConfig) apiObj[i] = apiConfig[i](request)
  inject('api', apiObj)
}
